import { Box, Card, CardContent, Chip, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
	timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { getEuDdpOrder, getEuDdpOrderIsLoad } from 'redux/reducers/euDdp/selectors';
import { TSwissPostOrderHistory } from 'redux/reducers/shipments/types';

export const ShipmentTimeLine: FC = () => {
	const orderIsLoading = useSelector(getEuDdpOrderIsLoad);
	const order = useSelector(getEuDdpOrder);
	const orderHistory = order?.orderHistory ?? [];
	const timeLine: TSwissPostOrderHistory =
		orderHistory.length > 0
			? orderHistory
			: [
					{
						emId: order?.order.emId ?? 0,
						orderId: order?.order.id ?? 0,
						statusCode: 'unfulfilled',
						statusDate: DateTime.now().toISO(),
						statusName: 'Unfulfilled',
					},
				];

	return (
		<Box>
			{order && !orderIsLoading ? (
				<Box sx={{ maxWidth: '100vw', overflowX: 'auto', width: '100%' }}>
					<Box sx={{ minWidth: '420px', width: '100%' }}>
						<Card
							sx={{
								width: '100%',
								mb: 2,
								'&': {
									borderRadius: '12px',
								},
							}}
						>
							<CardContent>
								<Box
									sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
								>
									<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
										Shipment Timeline
									</Typography>
								</Box>
								<Box sx={{ mt: 1.5, m: 0 }}>
									<Timeline
										sx={{
											m: 0,
											p: 0,
											[`& .${timelineOppositeContentClasses.root}`]: {
												flex: '1 0 0',
												maxWidth: '220px',
											},
											[`& .MuiTimelineItem-root`]: {
												minHeight: '50px',
											},
										}}
										position="right"
									>
										{timeLine?.map((item, index) => (
											<TimelineItem key={item.statusName} color="primary">
												<TimelineOppositeContent
													color="textSecondary"
													sx={{ fontSize: '0.8rem', m: 0, pl: 0, alignItems: 'left' }}
												>
													{!!timeLine?.[index]?.statusDate &&
														DateTime.fromISO(timeLine?.[index]?.statusDate).toFormat(
															'yyyy-MM-dd, HH.mm',
														)}
												</TimelineOppositeContent>
												<TimelineSeparator>
													<TimelineDot color={timeLine?.[index]?.statusDate ? 'primary' : 'grey'} />
													{index !== (timeLine?.length ?? 0) - 1 && (
														<TimelineConnector
															sx={{
																backgroundColor: timeLine?.[index]?.statusDate
																	? 'primary.main'
																	: '',
															}}
														/>
													)}
												</TimelineSeparator>
												<TimelineContent sx={{ pr: 0 }}>
													<Chip
														label={item.statusName}
														color={timeLine?.[index]?.statusDate ? 'primary' : 'default'}
														size="small"
														sx={{
															fontSize: '.7rem',
															height: '20px',
															bgcolor: timeLine?.[index]?.statusDate ? 'primary.light' : 'grey.300',
															color: '#000000a5',
														}}
													/>
												</TimelineContent>
											</TimelineItem>
										))}
									</Timeline>
								</Box>
							</CardContent>
						</Card>
					</Box>
				</Box>
			) : (
				<Skeleton variant="rectangular" height="500px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</Box>
	);
};
